import { mapGetters } from "vuex";
import {
  forEach as _forEach,
  isEmpty as _isEmpty,
} from "lodash";

export default {
  computed: {
    ...mapGetters({
      currentAction: "navigation/activeAction",
      currentStep: "navigation/activeStep",
      validationResults: "forms/validationResults"
    }),
    enabledActionsFields() {
      return this.$root.campaignSettings.formFields
    },
    formFieldValidations() {
      const currentActionFields =
        this.enabledActionsFields[this.currentAction] || {};

      const stepFields = currentActionFields[this.currentStep] || {};

      const validations = {};

      _forEach(Object.values(stepFields), formField => {
        const isFieldSkippable = formField.skippable;
        const isFieldRequired =
          (formField.validationRules && formField.validationRules.required) ||
          false;
        const isFieldEnabled = formField.isOn;
        const validationResultsForAction =
          this.validationResults[this.currentAction] || {};
        const hasFailedValidation = !_isEmpty(
          validationResultsForAction[formField.name]
        );
        const isFieldFilled =
          this.formValues[formField.name] &&
          !_isEmpty(this.formValues[formField.name]);

        validations[formField.name] = {
          isFieldSkippable,
          isFieldRequired,
          isFieldFilled,
          isFieldEnabled,
          hasFailedValidation
        };
      });
      return validations;
    },
    /**
     * The form will be valid if none of the required fields is invalid.
     * A required field is invalid if it was not filled or it was filled but its validation failed
     * @returns {boolean}
     */
    isFormValid() {
      let formIsValid = true;

      _forEach(this.formFieldValidations, formField => {
        const {
          isFieldRequired,
          isFieldEnabled,
          hasFailedValidation,
          isFieldFilled
        } = formField;

        if (
          isFieldRequired &&
          isFieldEnabled &&
          (hasFailedValidation || !isFieldFilled)
        ) {
          formIsValid = false;
        }
      });
      return formIsValid;
    },
    /**
     * The form will be skippable if all fields are optional and there are no errors with validation or fields
     * are not filled out.
     * @returns {boolean}
     */
    isFormSkippable() {
      let formIsSkippable = !_isEmpty(this.currentStep);

      _forEach(this.formFieldValidations, formField => {
        const {isFieldSkippable, isFieldFilled} = formField;

        if (!isFieldSkippable || isFieldFilled) {
          formIsSkippable = false;
        }
      });
      return formIsSkippable;
    }
  },
};
